import { render, staticRenderFns } from "./ExternalAddAudiencePage.vue?vue&type=template&id=6f1637c2&"
import script from "./ExternalAddAudiencePage.vue?vue&type=script&lang=ts&"
export * from "./ExternalAddAudiencePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports